<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Link" transform="translate(-138.000000, -7.000000)" fill="currentColor">
        <g
          id="Actions-/-Formatting-/-spell-check-/-24"
          transform="translate(135.000000, 4.000000)"
        >
          <path
            d="M15,16.5 L16.5,16.5 L12.75,7.5 L11.25,7.5 L7.5,16.5 L9,16.5 L9.93,14.25 L14.0775,14.25 L15,16.5 Z M10.5525,12.75 L11.9175,9.435 L12.105,9.435 L13.5,12.75 L10.5525,12.75 Z M9,21 L4.5,21 C3.67157288,21 3,20.3284271 3,19.5 L3,4.5 C3,3.67157288 3.67157288,3 4.5,3 L19.5,3 C20.3284271,3 21,3.67157288 21,4.5 L21,12.75 L19.5,12.75 L19.5,4.5 L4.5,4.5 L4.5,19.5 L9,19.5 L9,21 Z M17.25,20.385 L15.3075,18.4425 L14.25,19.5 L17.25,22.5 L22.5,17.25 L21.4425,16.1925 L17.25,20.385 Z"
            id="Fill"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Spellcheck'
};
</script>
